import * as Yup from "yup";

export const LanguageSchema = Yup.object().shape({
  name: Yup.string().required("Language name is required"),
  code: Yup.string().required("Language code is required"),
  rtl: Yup.boolean().required("Language rtl is required"),
});
